import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { UserAudit } from 'src/app/core/models/userAudit';
import { environment } from 'src/environments/environment';
import { Evento } from '../../../assets/proto-ts/evento';


@Injectable({
  providedIn: 'root',
})
export class HyundaiBluelinkService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient, private httpServer: HttpClient) {}

  public getPositionHyundai(chassi: string, userAudit: UserAudit)
    : Observable<Evento> {
      return this.http.post<Evento>(
        `${this.apiServerUrl}/api/hyundaiBluelink/requestLocationHyundai/` + chassi,
        userAudit
      );
    }

  public getHistoryHyundai(chassi: string, userAudit: UserAudit)
  : Observable<Evento> {
    return this.http.post<Evento>(
      `${this.apiServerUrl}/api/hyundaiBluelink/requestLocationHyundai/history/` + chassi,
      userAudit
    );
  }

}
